exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-e5694e54]{border:2px solid #273147;border-radius:5px}.well[data-v-e5694e54]{border-radius:15px;border:1px solid #273147;background-color:#172131}.well2[data-v-e5694e54]{border-radius:15px;border:1px solid #273147;background-color:#080d16}@media (max-width:992px){h1[data-v-e5694e54]{font-size:1.8rem}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-e5694e54","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/GameDetail.vue
// module id = 58
// module chunks = 0